export default "__VITE_ASSET__DgiVk5bN__"